import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';

const list = [
    {
        path: '/app',
        component: HeaderAsideLayout,
        children: [],
    }
]
export default list